export const AIRLINE_IATA_NAMES: Record<string, string> = {
    'PC': 'Pegasus Airlines',
    'XQ': 'SunExpress',
    'SK': 'SAS',
    'DY': 'Norwegian',
    'D8': 'Norwegian',
    'TK': 'Turkish Airlines',
    'VF': 'AJet',
    'XC': 'Corendon Airlines',
    'XR': 'Corendon Airlines',
    'CXI': 'Corendon Airlines',
    'FH': 'Freebird Airlines',
    'BHA': 'BH Air',
    'FB': 'Bulgaria Air',
    'OS': 'Austrian Airlines',
    'LH': 'Lufthansa',
    'LX': 'SWISS',
    'AY': 'Finnair',
    'KL': 'KLM',
    'AF': 'Air France',
    'BA': 'British Airways',
    'FR': 'Ryanair',
    'W6': 'Wizz Air',
    'U2': 'easyJet',
    'TO': 'Transavia',
    'HV': 'Transavia',
    'EW': 'Eurowings',
    'QS': 'Smartwings',
    'DE': 'Condor',
    'X3': 'TUI fly',
    'BY': 'TUI Airways',
    'BLX': 'TUI fly Nordic',
    '6B': 'TUI fly Nordic',
    'DK': 'Sunclass Airlines',
    'VK': 'Sunclass Airlines',
    'MS': 'EgyptAir',
    'SM': 'Air Cairo',
    'NP': 'Nile Air',
    'UJ': 'AlMasria Universal Airlines',
    'FZ': 'flydubai',
    'G9': 'Air Arabia',
    'EK': 'Emirates',
    'QR': 'Qatar Airways'
};

export const getAirlineNameByCode = (code?: string): string => {
    if (!code) return '';
    const clean = String(code).trim().toUpperCase();
    return AIRLINE_IATA_NAMES[clean] || '';
};

export const resolveAirlineName = (rawName?: any, code?: string, flightNo?: string): string => {
    let name = '';
    if (typeof rawName === 'string') name = rawName.trim();
    else if (rawName && typeof rawName === 'object' && rawName.name) name = String(rawName.name).trim();

    const isAggregatorOrCharter = !name || /charter|travelport|global|amadeus|galileo|sabre/i.test(name);

    const flightIata = (flightNo ? String(flightNo).replace(/[^A-Za-z0-9]/g, '').match(/^([A-Za-z]{2})/i)?.[1] : '') || '';
    const codeToTry = (code || flightIata).toUpperCase();

    if (codeToTry && AIRLINE_IATA_NAMES[codeToTry]) {
        if (isAggregatorOrCharter || !name) {
            return AIRLINE_IATA_NAMES[codeToTry];
        }
        return name;
    }

    if (name && !/charter/i.test(name)) return name;
    return flightNo || '';
};
